import {
  CONSIGNMENT_RESULT_SET,
  CONSIGNMENT_RESULT_RESET
} from "../actionNames";

export function setResult(message, success) {
  return dispatch => {
    dispatch({
      type: CONSIGNMENT_RESULT_SET,
      result: { message, success }
    });

    return setTimeout(() => {
      dispatch({
        type: CONSIGNMENT_RESULT_RESET
      });
    }, 5000);
  };
}

export function resetResult() {
  return dispatch =>
    dispatch({
      type: CONSIGNMENT_RESULT_RESET
    });
}
